import React, {useEffect, useMemo, useRef, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  updateAdults,
  updateRoomPriceStructure,
  updateSelectedRoomWTypeAndNum,
  updateRoomChangeMade,
} from "../../../../reducer/bookingReducer";
import { Input, Button, ConfigProvider } from "antd";
import { MdCurrencyRupee } from "react-icons/md";
import { FaMinus } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa6";
import { FormControl, MenuItem, Select } from "@mui/material";
import useAllBookingFunction from "../../../../hooks/bookingCustomHook/useAllBookingFunction";
import {FaCog} from "react-icons/fa";
import {createPortal} from "react-dom";
import {getRoomRateInitialEditBooking, calculateInitialValuesOfExtraEditBooking} from "../../../../utils/helper";
import { message } from "antd";

const IndivualRoomTypeDetail = ({ roomTypeObj }) => {
  const dispatch = useDispatch();
  const [showExtras, setShowExtras] = useState(false);
  const [popoverStyle, setPopoverStyle] = useState({});
  const wrapperRef = useRef(null);
  const popoverRef = useRef(null);
  const triggerRef = useRef(null);
  const {
    selectedRoomWTypeAndNum,
    roomPriceStructure,
    adults,
    detailedPriceBreakup,
    mealPlan,
    roomRateEditable,
  } = useSelector((store) => store.booking);
  // const [extras, setExtras] = useState(() => calculateInitialValuesOfExtraEditBooking(roomTypeObj, detailedPriceBreakup));
  // const [tempRate, setTempRate] = useState(() => getRoomRateInitialEditBooking(roomTypeObj, detailedPriceBreakup)); // Temporary state for debouncing
  const roomTypeName = Boolean(roomTypeObj?.name) ? roomTypeObj?.name : "-";
  const roomTypeRate = useMemo(() => {
    if(roomPriceStructure && typeof roomPriceStructure === 'object' && roomPriceStructure.length > 0) {
    return roomPriceStructure?.find((rps) => rps.name === roomTypeName) || {};
    } else return {};
  },[roomPriceStructure]);
  const value = Boolean(selectedRoomWTypeAndNum[roomTypeObj.name])
    ? selectedRoomWTypeAndNum[roomTypeObj.name]?.length
    : 0;

  const remainingAvailability = useMemo(() => {
    return (
      roomTypeObj?.availability -
      (selectedRoomWTypeAndNum[roomTypeObj?.name]?.length || 0)
    );
  }, [roomTypeObj, selectedRoomWTypeAndNum]);

  const currentPeople = useMemo(() => {
    const roomsList = selectedRoomWTypeAndNum[roomTypeObj?.name];
    let count = 0;
    roomsList?.forEach(room=>{
      count += room?.occupancy || 0;
    })
      return count;
  }, [selectedRoomWTypeAndNum, roomTypeObj]);
  
  // Calculate adults and children for this room type
  const roomTypeGuests = useMemo(() => {
    let adults = 0;
    let children = 0;
    
    if(selectedRoomWTypeAndNum && selectedRoomWTypeAndNum[roomTypeObj?.name]){
      selectedRoomWTypeAndNum[roomTypeObj?.name]?.forEach(r => {
        adults += r.adults || r.occupancy || 0;
        children += r.children || 0;
      });
    }
    
    // If no specific adult/child data, assume all are adults
    if (adults === 0 && children === 0 && currentPeople > 0) {
      adults = currentPeople;
    }
    
    return { adults, children };
  }, [selectedRoomWTypeAndNum, roomTypeObj, currentPeople]);

    let rate = detailedPriceBreakup?.find(dpb=>dpb?.name === roomTypeName)?.baseRate ||  roomTypeObj?.rate || 0;
  rate =
    typeof rate === "number" && !isNaN(rate) ? parseFloat(rate.toFixed(2)) : "";

  


  const {
    handleRoomCountOfRoomTypeChangeInUpdateBooking,
    handleGuestChangeInRoomTypeUpdateBooking,
  } = useAllBookingFunction();



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
          popoverRef.current &&
          !popoverRef.current.contains(event.target) &&
          !wrapperRef.current.contains(event.target)
      ) {
        setShowExtras(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleRoomChangeBtn = (newValue, action) => {
    handleRoomCountOfRoomTypeChangeInUpdateBooking({
      count:newValue,
      roomTypeObj,
    });
  };
  const handleValueInputChange = (newValue)=>{
    handleRoomCountOfRoomTypeChangeInUpdateBooking({
      count: newValue,
      roomTypeObj
    }
    )
  }
    const maxGuestsPerRoom = roomTypeObj?.maxGuestAllowed || roomTypeObj?.guestsAllowed || 4;
  const selectedRooms = selectedRoomWTypeAndNum[roomTypeObj?.name] || [];
  const totalRooms = selectedRooms?.length || 0;
  const totalCapacity = totalRooms * maxGuestsPerRoom;

  // Calculate constraints
  const minAdults = totalRooms; // At least 1 adult per room
  const remainingCapacity = totalCapacity - roomTypeGuests?.adults;
  const onGuestChange = ({ adults: newAdults, children: newChildren }) => {
      handleGuestChangeInRoomTypeUpdateBooking({
        roomTypeObj,
        roomTypeName,
        adults: newAdults,
        children: newChildren
      });
    }
    const handleAdultChange = (value) => {
      if (value < minAdults) {
        message.warning(`At least ${minAdults} adult${minAdults > 1 ? 's' : ''} required for ${totalRooms} room${totalRooms > 1 ? 's' : ''}`);
        return;
      }
  
      if (value > totalCapacity) {
        message.warning(`Adults cannot exceed room capacity of ${totalCapacity}`);
        return;
      }
  
      // Reset children to 0 when adults are changed
      onGuestChange({
        adults: value,
        children: 0,
      });
    };
  
    const handleChildrenChange = (value) => {
      if (roomTypeGuests?.adults + value > totalCapacity) {
        message.warning(`Total guests cannot exceed room capacity of ${totalCapacity}`);
        return;
      }
  
      // Just update children, don't touch adults
      onGuestChange({
        adults: roomTypeGuests?.adults,
        children: value,
      });
    };
  

  return (
    <div
      className={`   bg-surface h-[68px] font-body flex justify-between items-center w-[100%]`}
      key={roomTypeObj?.name}
    >
      <div
        className="cursor-default  w-[20%]   pl-3  py-4  
                        text-fg font-[500] 
                        text-[14px] leading-[20x] capitalize"
      >
        {roomTypeName}
      </div>

      <div className="cursor-default  flex justify-center items-center whitespace-nowrap w-[14%]   px-6 py-4  ">
        <span className=" text-[14px] text-fg leading-[20px] font-[500]">
          {remainingAvailability < 10
            ? "0" + remainingAvailability
            : remainingAvailability}
        </span>
      </div>

      <div className=" w-[20%] flex justify-center items-center relative">
        {roomRateEditable ? (
            <div>
          <div className="relative " ref={wrapperRef}>
            <div className="flex items-center border-[0.5px] border-fg-muted rounded-md bg-primary-light overflow-hidden w-fit">

            <Input
              type="number"
              style={{
                width: "11ch",
                borderColor: "rgb(var(--color-text-muted))",
                outline: "none",

                "&:focus": {
                  borderColor: "rgb(var(--color-accent))",
                },
                "&:outline": {
                  borderColor: "rgb(var(--color-accent))",
                },
              }}
              className=" pl-4 py-1 bg-transparent flex font-body  text-fg-secondary font-[500]"
              value={ roomTypeRate?.rate || 0}
              defaultValue={roomTypeRate?.rate || 0}
              onChange={(e) => {
                let value = JSON.parse(JSON.stringify(roomTypeRate));;
                
              value.rate = Number(e.target.value);
                
                dispatch(updateRoomPriceStructure(roomPriceStructure?.filter(rps => rps.name !== roomTypeName).concat(value)));
              }}
            />

            <div className="absolute top-[9px] left-1 cursor-pointer">
              <MdCurrencyRupee className="text-[12px]" />
            </div>
              <div
                  ref={triggerRef}
                  className="cursor-pointer px-[6px] py-[3px] hover:bg-primary-light"
                  onClick={() => {
                    setShowExtras((prev) => {
                      if (!prev && triggerRef.current) {
                        const rect = triggerRef.current.getBoundingClientRect();
                        setPopoverStyle({
                          position: "fixed",
                          top: `${rect.bottom + 4}px`,
                          left: `${rect.left}px`,
                          zIndex: 9999,
                        });
                      }
                      return !prev;
                    });
                  }}
                  title="Add Extra Pricing"
              >
                <FaCog className="text-sm text-primary" />
              </div>
            </div>
          </div>
              {/* Popover with extra pricing fields */}
              {showExtras && createPortal(
                  <div ref={popoverRef}
                       style={popoverStyle}
                       className="w-56 bg-surface shadow-md border rounded-md p-3">
                    <div className="mb-2">
                      <label className="text-xs text-gray-600">Extra Guest Price</label>
                      <input
                          type="number"
                          className="w-full border px-2 py-1 rounded text-sm"
                          value={roomTypeRate?.extraAdultRate || 0}
                          onChange={(e) =>{
                           let value = JSON.parse(JSON.stringify(roomTypeRate));;
                
              value.extraAdultRate = Number(e.target.value);
              value.extraGuestRate = Number(e.target.value);
                
                dispatch(updateRoomPriceStructure(roomPriceStructure?.filter(rps => rps.name !== roomTypeName).concat(value)));
              }}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="text-xs text-gray-600">Extra Child</label>
                      <input
                          type="number"
                          className="w-full border px-2 py-1 rounded text-sm"
                          value={roomTypeRate?.extraChildRate || 0}
                          onChange={(e) =>{
                           let value = JSON.parse(JSON.stringify(roomTypeRate));;
                            value.extraChildRate = Number(e.target.value);
                dispatch(updateRoomPriceStructure(roomPriceStructure?.filter(rps => rps.name !== roomTypeName).concat(value)));
                          }
                          }
                      />
                    </div>
                    <div>
                      <label className="text-xs text-gray-600">Single Guest Price Reduction</label>
                      <input
                          type="number"
                          className="w-full border px-2 py-1 rounded text-sm"
                          value={roomTypeRate?.singleGuestPriceReduction || 0}
                          onChange={(e) =>{
                           let value = JSON.parse(JSON.stringify(roomTypeRate));;
                            value.singleGuestPriceReduction = Number(e.target.value);
                dispatch(updateRoomPriceStructure(roomPriceStructure?.filter(rps => rps.name !== roomTypeName).concat(value)));
                          }
                          }
                      />
                    </div>
                  </div>,document.body
              )}
          </div>
        ) : (
          <div className="flex gap-4 items-center">
            {" "}
            <div className="font-body font-[500] w-[80%] text-[16px] leading-[20px] text-fg ">
              &#x20B9;{roomTypeObj?.rate}
            </div>
          </div>
        )}
      </div>

      <div className="w-[20%] flex justify-center items-center">
        
                  <FormControl
                    sx={{
                      width: "4rem",
                      color: "rgb(var(--color-neutral-400))",
                      "& .MuiSelect-icon": { color: "rgb(var(--color-accent))" },
                    }}
                    size="small"
                  >
                    <Select
                      data-testid="adults-dropdown"
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 200, // Limit the height of the dropdown
                          },
                        },
                      }}
                      sx={{
                        borderRadius: "6px",
                        color: "rgb(var(--color-text-muted))",
                        fontSize: "0.75rem",
                        fontWeight: "400",
                        fontFamily: "var(--font-body)",
                      }}
                      value={roomTypeGuests?.adults}
                      onChange={(e)=>handleAdultChange(e.target.value)}
                      style={{ width: 80 }}
                      size="small"
                      disabled={totalRooms === 0}
                    >
                      {Array.from({ length: totalCapacity + 1 }, (_, i) => i).map(
                        (i) =>
                          i >= minAdults && (
                            <MenuItem key={i} value={i} sx={{ fontSize: "15px" }}>
                              {i}
                            </MenuItem>
                          )
                      )}
                    </Select>
                  </FormControl>
      </div>
      <div
        data-testid="children-selectors"
        className="w-[13%] flex justify-center items-center"
      >          <FormControl
            sx={{
              width: "4rem",
              color: "rgb(var(--color-neutral-400))",
              "& .MuiSelect-icon": { color: "rgb(var(--color-accent))" },
            }}
            size="small"
          >
            <Select
              data-testid="children-dropdown"
              value={roomTypeGuests?.children}
              onChange={(e)=>handleChildrenChange(e.target.value)}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 200, // Limit the height of the dropdown
                  },
                },
              }}
              sx={{
                borderRadius: "6px",
                color: "rgb(var(--color-text-muted))",
                fontSize: "0.75rem",
                fontWeight: "400",
                fontFamily: "var(--font-body)",
              }}
              size="small"
              disabled={totalRooms === 0 || remainingCapacity === 0}
            >
              {Array.from({ length: remainingCapacity + 1 }, (_, i) => (
                <MenuItem key={i} value={i}>
                  {i}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

      <div className="px-4 w-[20%] flex justify-center items-center font-body">
        {Boolean(roomTypeObj?.countButtonVisible) ? (
          <div className="flex gap-[6px] justify-center  items-center  h-[4rem]">
            <ConfigProvider
              theme={{
                components: {
                  Button: {
                    defaultHoverBg: "rgb(var(--color-primary-light))", // Added quotes around the color value
                  },
                },
              }}
            >
              <Button
                icon={<FaMinus className="text-[16px]" />}
                className="border-0 w-[36px] text-primary hover:bg-primary-light bg-primary-light text-[20px]"
                onClick={() => handleRoomChangeBtn(value - 1, "dec")}
              />
            </ConfigProvider>

            <Input
              className="border-[1px] focus:w-[7ch] w-[5ch] border-primary text-center"
              onChange={(e) =>
                handleValueInputChange(e.target.value)
              }
              value={value}
            />

            <ConfigProvider
              theme={{
                components: {
                  Button: {
                    defaultHoverBg: "rgb(var(--color-primary-light))", // Added quotes around the color value
                  },
                },
              }}
            >
              <Button
                icon={<FaPlus className="text-[16px]" />}
                className="border-0  w-[36px] text-primary    bg-primary-light text-[20px] "
                onClick={() => handleRoomChangeBtn(value + 1, "inc")}
              />
            </ConfigProvider>
          </div>
        ) : (
          <div className="w-[7rem] h-[4rem] flex justify-center items-center">
            <Button
              className="   rounded-md h-[2rem] w-[6rem]  
               font-[400] text-[14px] border-[1px] border-primary
                text-primary bg-primary-light "
              onClick={() => handleRoomChangeBtn(1, "inc")}
            >
              Select Room
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(IndivualRoomTypeDetail);
